import type { IconProps } from "./CircleIcon";

export const PinIcon = ({ className, style }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    style={style}
  >
    <path
      d="M8 15.8183L3.75736 11.5757C1.41421 9.23247 1.41421 5.43351 3.75736 3.09037C6.10051 0.747221 9.89947 0.747221 12.2427 3.09037C14.5858 5.43351 14.5858 9.23247 12.2427 11.5757L8 15.8183ZM11.2998 10.6328C13.1223 8.81041 13.1223 5.85562 11.2998 4.03317C9.4774 2.21073 6.52261 2.21073 4.70017 4.03317C2.87772 5.85562 2.87772 8.81041 4.70017 10.6328L8 13.9327L11.2998 10.6328ZM8 8.66634C7.2636 8.66634 6.66667 8.06941 6.66667 7.33301C6.66667 6.59663 7.2636 5.99967 8 5.99967C8.7364 5.99967 9.33333 6.59663 9.33333 7.33301C9.33333 8.06941 8.7364 8.66634 8 8.66634Z"
      fill="currentColor"
    />
  </svg>
);
